"use strict";exports.toArray=function(r){return null==r?[]:Array.isArray(r)?r:[r]};
